import { IPV6_RA_MODES } from '@/common/constants/networks.constants';
import Model from '@/common/models/common.model';
import { Subnet as SubnetSchema } from '@schema';

export default class Subnet extends Model {
  declare attributes: SubnetSchema;

  get networkId() {
    return this.attributes.network_id;
  }

  get cidr() {
    return this.attributes.cidr;
  }

  get ipVersion() {
    return this.attributes.ip_version;
  }

  get kind() {
    return `ipv${this.attributes.ip_version}`;
  }

  get allocationPools(): AllocationPool[] {
    return this.attributes.allocation_pools ? this.attributes.allocation_pools.map(pool => ({
      startAddress: pool.start,
      endAddress: pool.end,
    })) : [];
  }

  get dnsNameservers(): string[] {
    return this.attributes.dns_nameservers
      ? this.attributes.dns_nameservers.filter(it => it !== '0.0.0.0')
      : [];
  }

  get gatewayIp() {
    return this.attributes.gateway_ip || '';
  }

  get enableDhcp() {
    return this.attributes.enable_dhcp;
  }

  get ipv6RaMode() {
    return this.attributes.ipv6_ra_mode || '';
  }

  get ipv6AddressMode() {
    return this.attributes.ipv6_address_mode || IPV6_RA_MODES.NONE;
  }
}
